module.exports = __webpack_public_path__ + "img/Gr4.322997be.png";